<template>
  <div id="inside" v-if="showNoContractsOrAgreements">
    <div class="container">
      <div class="row">
        <div class="align-items-center justify-content-center col-sm-12 col-12 d-flex col-md-12 col-lg-12 px-4">
          <i class="fa fa-2x fa-exclamation-circle pull-left mr-4 mb-2 text-primary"></i>
          <h4 class="py-4 text-primary">
            No momento não temos uma oferta disponível para você.
          </h4>
        </div>
      </div>
      <div class="row pb-5">
        <div class="align-items-center justify-content-center col-sm-12 col-12 d-flex col-md-12 col-lg-12 px-4">
          <h6 class="py-2 text-muted">
            Conte com a gente para ter um alívio financeiro! É só selecionar o
            produto e acionar o atendimento que preferir:
          </h6>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 col-lg-3 px-4">
          <h4 class="py-4">Central de Relacionamento Cartão de Crédito</h4>
          <p>
            <a href="tel:40043600" target="_blank">4004 3600</a> - Capitais e
            regiões metropolitanas.&nbsp;<br /><a href="tel:08007277477" target="_blank">0800 727 7477</a>
            - Demais localidades.&nbsp;<br /><a href="tel:551133663216" target="_blank">+55 11 3366 3216</a>
            - Atendimento no exterior.&nbsp;<br />De segunda a sexta-feira, das
            8h às 18h30.
          </p>
        </div>
        <div class="p-0 px-4 col-12 col-lg-3">
          <h4 class="py-4">
            Central de Relacionamento Cartão de Crédito Empresarial
          </h4>
          <p>
            <a href="tel:1140043600" target="_blank">4004 3600</a> - Capitais e
            regiões metropolitanas.<br /><a href="tel:08007277477" target="_blank">0800-727-7477</a>
            - Demais localidades.&nbsp;<br />De segunda à sexta das 7h40 às
            19h00.
          </p>
        </div>
        <div class="p-0 px-4 col-12 col-lg-3">
          <h4 class="py-4">
            Central de Relacionamento Empréstimo e Financiamento
          </h4>
          <p>
            <a href="tel:40045215" target="_blank">4004 5215</a>&nbsp;<br />De
            segunda a sexta-feira, das 8h às 19h (exceto feriados).
          </p>
        </div>
        <div class="p-0 px-4 col-12 col-lg-3">
          <h4 class="py-4">SAC</h4>
          <p>
            <a href="tel:08007272745" target="_blank">0800 727 2745</a><br />Atendimento 24 horas.
          </p>
        </div>
      </div>
    </div>
    <HomeOptions />
  </div>
  <div id="inside" v-else>
    <div class="container mt-2">
      <div v-bind:class="[
        largura < 500 ? 'col-12 col-lg-12 p-2' : 'header-content-desktop',
      ]">
        <div class="row">
          <div class="col-6">
            <h5 class="text-wrapper-2 m-0" style="color: #2c3da8">
              Olá, {{ (user?.FullName != null && String(user.FullName).trim()) ? String(user.FullName).trim().split(/\s+/)[0] : 'Devedor' }}!
            </h5>
          </div>
          <div class="col-6 text-right">
            <p class="text-info mb-0" style="font-style: italic">
              CPF
              {{
                formatDocument(user.DocNumber).split(".")[0].substring(0, 6) +
                ".xxx.xxx-" +
                formatDocument(user.DocNumber).split("-")[1]
              }}
            </p>
          </div>
          <div class="col-12">
            <p class="mb-2 mt-4" style="font-style: italic; color: black">
              Confira as opções de negociação disponíveis:
            </p>
          </div>
          <div class="col-12" v-if="thereIsDebts">
            <h5 class="text-bold mt-2" style="color: black">
              Negociações disponíveis
            </h5>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!--row debts-->

      <div v-bind:class="[largura < 500 ? '' : 'cards-container-desktop']" style="">
        
        <!-- DEBTS (Cartões/Faturas) -->
        <div v-bind:class="[
          largura < 500
            ? ''
            : 'card-wrapper-desktop',
        ]" v-for="(value2, key2, index2) in debts" :key="`${'b' + key2}-${index2}`">
          <div v-bind:class="[largura < 500 ? 'card mb-4 m-2' : 'card']" style="min-height: 265px">
            <div class="card-header pl-3 pt-3 pr-3">
              <div class="row">
                <div class="col-12">
                  <h5 class="mb-0" style="color: black">
                    {{ value2.product }}&nbsp;
                  </h5>
                  <p style="font-size: 10pt">Contrato: {{ value2.contract }}</p>
                </div>
              </div>
              <hr class="mt-0 mb-2" />
            </div>
            <div v-bind:class="[
              largura < 500 ? 'card-body pt-1 pl-3 pr-3' : 'card-body pt-2',
            ]">
              <div class="row">
                <div class="d-flex col-lg-12 col-12">
                  <p class="mb-1 mr-2" style="font-size: 10pt">
                    Valor original da fatura:
                  </p>
                  <h6 class="text-bold">
                    {{
                      formatFloatToReal(parseFloat(value2.originalValue, 10))
                    }}
                  </h6>
                </div>
                <div class="d-flex col-12 col-lg-12 mt">
                  <p class="mb-1 mr-2" style="font-size: 10pt">
                    Vencimento original da fatura:
                  </p>
                  <p class="mb-0" style="color: black">
                    {{ formatData(value2.dueDate, "YYYY-MM-DD", "L") }}
                  </p>
                </div>
              </div>
              <div class="row mt-3">
                <div class="d-flex flex-column col-8">
                  <div class="mb-0" style="margin-bottom: 0; font-weight: bold">
                    {{
                      formatFloatToReal(parseFloat(value2.originalValue, 10))
                    }}
                    à vista
                  </div>
                  <div class="mb-0" style="margin-bottom: 0" v-if="value2.offerDueDate !== null">
                    <p style="font-size: 9pt; margin-bottom: 0">
                      para pagamento até
                      {{ formatData(value2.offerDueDate, "YYYY-MM-DD", "L") }}
                    </p>
                  </div>
                  <div class="mb-0" style="margin-bottom: 0" v-if="value2.maxPaymentsOption !== null">
                    <p style="margin-bottom: 0; font-size: 11pt">
                      ou parcelado em até {{ value2.maxPaymentsOption }}x
                    </p>
                  </div>
                </div>
              </div>
              <div v-bind:class="[
                largura < 500
                  ? 'row d-flex justify-content-center mt-1'
                  : 'row d-flex justify-content-center mt-3',
              ]">
                <div v-bind:class="[
                  largura < 500
                    ? 'text-center col-md-12 mt-4'
                    : 'text-center col-md-12 mt-3',
                ]">
                  <button class="btn mb-2 btn-primary p-3" style="width: 100%; border-radius: 20px; font-size: 18px"
                    @click="verBoletos(value2)">
                    EMITIR FATURA
                  </button>
                  <button class="custom-button" style="" @click="offersFaturaPropostas(value2)">
                    NEGOCIAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- DEBTS CONSORCIO -->
        <div v-bind:class="[
          largura < 500
            ? ''
            : 'card-wrapper-desktop',
        ]" v-for="(value5, key5, index) in debtsConsorcio" :key="`${'e' + key5}-${index}`">
          <div v-bind:class="[largura < 500 ? 'card mb-4 m-2' : 'card']">
            <div class="card-header pr-3 pl-3 pt-3 pb-0" @click="toggleDropdownDetailsDebtsConsorcio(value5)"
              style="cursor: pointer;">
              <div class="row">
                <div class="col-10">
                  <h5 style="color: black">{{ fromToConsorcioProduct[value5.product] }}</h5>
                  <p style="color: gray; font-weight: lighter;" class="mb-0">Grupo: {{ value5.group }}</p>
                  <p style="color: gray; font-weight: lighter;" class="mb-1">Cota: {{ value5.cota }}</p>
                  <p style="color: black; font-weight: bold;" class="mb-1">{{ fromToConsorcioType[value5.type] }}</p>
                </div>
                <div class="col-2 d-flex justify-content-end align-items-start">
                  <i v-if="!isCardConsorcioExpanded(value5)" class="fa fa-angle-down fa-lg"></i>
                  <i v-else class="fa fa-angle-up fa-lg"></i>
                </div>
              </div>
            </div>
            <div class="card-body pr-3 pl-3 pt-0 pb-3" v-if="isCardConsorcioExpanded(value5)">
              <hr class="mt-0" />
              <div class="row">
                <div class="col-12 col-lg-12">
                  <p class="mb-0" style="font-size: 10pt; color: gray; white-space: pre-line;">{{
                    getInstallmentsConsorcioRange(value5.installments) }}</p>
                  <p class="mb-0" style="font-size: 10pt; color: gray;">
                    Valor: R$
                    <span style="font-weight: bold; color: black;">
                      {{
                        value5.originalValue.toLocaleString("pt-BR", {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        })
                      }}
                    </span>
                  </p>
                  <p class="mb-2" style="font-size: 10pt; color: gray;">Vencimento:
                    <span style="font-weight: bold; color: black;">
                      {{ formatData(
                        value5.installments[0].dueDate,
                        "YYYY-MM-DD",
                        "L"
                      ) }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="text-center col-md-12 mt-3">
                  <!-- Mensagem para redirecionamento ao WhatsApp quando mais de 30 dias -->
                  <div v-if="shouldRedirectConsorcioToWhatsApp(value5)" class="alert alert-warning mb-2 p-2" style="font-size: 11px;">
                    <i class="fa fa-exclamation-triangle mr-1" style="color: #856404;"></i>
                    Para prosseguir, por favor, clique no botão de WhatsApp.
                    <br>
                    <!-- <a href="https://api.whatsapp.com/send?l=pt&phone=551132303765" target="_blank" 
                       class="btn btn-success btn-sm mt-2" style="background-color: #25D366; border-color: #25D366;">
                      <i class="fa fa-whatsapp mr-1"></i> WhatsApp
                    </a> -->
                  </div>
                  <button class="btn mb-2 btn-primary p-3" style="width: 100%; border-radius: 20px; font-size: 18px"
                    :disabled="(checkedParcels.length <= 0 && value5.selected) ||
                      thereIsAgreementCdcClosed(value5.contract) ||
                      shouldRedirectConsorcioToWhatsApp(value5)
                      " @click="offersConsorcio(value5)">
                    NEGOCIAR
                  </button>
                </div>
              </div>
              <div class="row mt-3 mb-4 px-2" v-if="thereIsAgreementCdcClosed(value5.contract)">
                <div class="col-lg-1 text-center px-1 col-1">
                  <i class="fa fa-info-circle text-danger"></i>
                </div>
                <div class="px-1 col-lg-11 col-11">
                  <p class="small">
                    Existe um acordo em andamento, por isso não é possível fazer
                    uma nova negociação.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- DEBTS CDC -->
        <div v-bind:class="[
          largura < 500
            ? ''
            : 'card-wrapper-desktop',
        ]" v-for="(value, key, index) in debtsCdc" :key="`${'a' + key}-${index}`">
          <div v-bind:class="[largura < 500 ? 'card mb-4 m-2' : 'card']">
            <div class="card-header pr-3 pl-3 pt-3 pb-0">
              <div class="row">
                <div class="col-12">
                  <h5 style="color: black">{{ value.product }}</h5>
                  <p style="color: black">Contrato: {{ value.contract }}</p>
                </div>
              </div>
              <hr class="mt-0" />
            </div>
            <div class="card-body pr-3 pl-3 pt-0 pb-3">
              <div class="row">
                <div class="col-12 col-lg-12">
                  <p class="mb-1">Valor total para negociação:</p>
                  <p class="" style="font-weight: 700; font-size: 14pt">
                    {{
                      formatFloatToReal(parseFloat(value.originalValue, 10))
                    }}
                  </p>
                </div>
                <div class="d-flex col-12 col-lg-12 pr-0" style="align-items: center">
                  <p class="mb-1">Data da parcela mais atrasada:&nbsp;</p>
                  <h6 class="mt-1">
                    {{
                      formatData(
                        value.installments[0].dueDate,
                        "YYYY-MM-DD",
                        "L"
                      )
                    }}
                  </h6>
                </div>
              </div>
              <div class="row">
                <div class="text-center col-md-12 mt-3">
                  <button class="btn mb-2 btn-primary p-3" style="width: 100%; border-radius: 20px; font-size: 18px"
                    :disabled="(checkedParcels.length <= 0 && value.selected) ||
                      thereIsAgreementCdcClosed(value.contract)
                      " @click="offersCdc(value)">
                    NEGOCIAR
                  </button>
                </div>
              </div>
              <div class="row mt-3 mb-4 px-2" v-if="thereIsAgreementCdcClosed(value.contract)">
                <div class="col-lg-1 text-center px-1 col-1">
                  <i class="fa fa-info-circle text-danger"></i>
                </div>
                <div class="px-1 col-lg-11 col-11">
                  <p class="small">
                    Existe um acordo em andamento, por isso não é possível fazer
                    uma nova negociação.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- DEBTS CONTENCIOSO -->
        <div v-bind:class="[
          largura < 500
            ? ''
            : 'card-wrapper-desktop',
        ]" v-for="(value3, key3, index3) in debtsContencioso" :key="`${'c' + key3}-${index3}`">
          <div v-bind:class="[largura < 500 ? 'card mb-4 m-2' : 'card']" style="min-height: 265px">
            <div class="card-header">
              <div class="row">
                <div class="col-12">
                  <h5 class="mb-0" style="color: black">
                    {{ value3.product }}&nbsp;
                  </h5>
                  <p style="font-size: 10pt">Contrato: {{ value3.contract }}</p>
                </div>
              </div>
              <hr class="mt-0 mb-2" />
            </div>
            <div v-bind:class="[largura < 500 ? 'card-body pt-1' : 'card-body']">
              <div class="row">
                <div class="d-flex col-lg-12 col-12">
                  <p class="mb-1 mr-2" style="font-size: 10pt">
                    Valor original da dívida:
                  </p>
                  <h6 class="text-bold">
                    {{
                      formatFloatToReal(parseFloat(value3.originalValue, 10))
                    }}
                  </h6>
                </div>
                <div class="d-flex col-12 col-lg-12 mt">
                  <p class="mb-1 mr-2" style="font-size: 10pt">
                    Vencimento original da dívida:
                  </p>
                  <h6>{{ formatData(value3.dueDate, "YYYY-MM-DD", "L") }}</h6>
                </div>
              </div>
              <div class="row mt-3">
                <div class="" v-bind:class="largura < 500
                  ? 'd-flex flex-column col-7'
                  : 'd-flex flex-column col-8'
                  ">
                  <div class="text-info" style="display: flex; margin-bottom: 0">
                    <p class="mr-2 mb-0">De</p>
                    <span style="text-decoration: line-through; margin-bottom: 0">
                      {{
                        formatFloatToReal(parseFloat(value3.paymentValue, 10))
                      }}
                    </span>
                    <p class="ml-2 mb-0">por</p>
                  </div>
                  <div class="mb-0" style="margin-bottom: 0; font-weight: bold">
                    {{ formatFloatToReal(parseFloat(value3.atSightValue, 10)) }}
                    à vista
                  </div>
                  <div class="mb-0" style="margin-bottom: 0">
                    <p style="font-size: 9pt; margin-bottom: 0">
                      para pagamento até
                      {{ formatData(value3.offerDueDate, "YYYY-MM-DD", "L") }}
                    </p>
                  </div>
                  <div class="mb-0" style="margin-bottom: 0" v-if="value3.maxPaymentsOption !== null">
                    <p style="margin-bottom: 0; font-size: 11pt">
                      ou parcelado em até {{ value3.maxPaymentsOption }}x
                    </p>
                  </div>
                </div>

                <div v-bind:class="largura < 500
                  ? 'col-5 text-right discount'
                  : 'col-4 text-center discount'
                  " v-if="value3.atSightPercentDiscount > 0">
                  <p class="mb-0 mr-2" style="font-size: 8pt">
                    Desconto de até
                  </p>
                  <span class="discount-value" style="font-size: 13pt">
                    {{ value3.atSightPercentDiscount }}%
                  </span>
                </div>
              </div>
              <div v-bind:class="[
                largura < 500
                  ? 'row d-flex justify-content-center mt-1'
                  : 'row d-flex justify-content-center mt-3',
              ]">
                <div v-bind:class="[
                  largura < 500
                    ? 'text-center col-md-12 mt-4'
                    : 'text-center col-md-12 mt-3',
                ]">
                  <button class="btn btn-primary mr-2 mb-4 p-3" style="width: 100%; border-radius: 20px"
                    @click="offersFaturaContencioso('negociar', value3)">
                    NEGOCIAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- DEBTS FIANCA -->
        <div v-bind:class="[
          largura < 500
            ? ''
            : 'card-wrapper-desktop',
        ]" v-for="(value4, key4, index4) in debtsFianca" :key="`${'d' + key4}-${index4}`">
          <div v-bind:class="[largura < 500 ? 'card mb-4 m-2' : 'card']" style="min-height: 265px">
            <div class="card-header">
              <div class="row">
                <div class="col-12">
                  <h5 class="mb-0" style="color: black">
                    Seguro Fiança - Essencial&nbsp;
                  </h5>
                  <p style="font-size: 10pt" class="mb-0">
                    <b style="color: black">Endereço da locação:</b>
                    {{ value4.address.street }}, {{ value4.address.number }} -
                    {{ value4.address.neighbourhood }}, <br />
                    {{ value4.address.cep }} {{ value4.address.city }} -
                    {{ value4.address.state }}
                  </p>
                  <p style="font-size: 10pt">
                    <b style="color: black">Sinistro:</b> {{ value4.clientCode }}
                  </p>
                </div>
              </div>
              <hr class="mt-0 mb-2" />
            </div>
            <div v-bind:class="[
              largura < 500 ? 'card-body pt-1' : 'card-body pt-0',
            ]">
              <div class="row mt-1">
                <div class="" v-bind:class="largura < 500
                  ? 'd-flex flex-column col-7'
                  : 'd-flex flex-column col-8 pr-0'
                  ">
                  <!-- v-if="
                      parseFloat(value4.paymentValue, 10) <
                      parseFloat(value4.originalValue, 10)
                    " -->
                  <div class="text-info" style="display: flex; margin-bottom: 0" v-if="value4.discount > 0">
                    <p class="mr-2 mb-0">De</p>
                    <span style="text-decoration: line-through; margin-bottom: 0">
                      {{
                        formatFloatToReal(parseFloat(value4.originalValue, 10))
                      }}
                    </span>
                    <p class="ml-2 mb-0">por</p>
                  </div>
                  <div class="mb-0" style="margin-bottom: 0; font-weight: bold">
                    {{ formatFloatToReal(parseFloat(value4.atSightValue, 10)) }}
                    à vista
                  </div>
                  <div class="mb-0" style="margin-bottom: 0">
                    <p style="font-size: 9pt; margin-bottom: 0">
                      para pagamento até
                      {{ formatData(value4.offerDueDate, "YYYY-MM-DD", "L") }}
                    </p>
                  </div>
                  <div class="mb-2 mt-1" style="margin-bottom: 0" v-if="value4.overDueInstallmentsNumber !== null">
                    <p style="margin-bottom: 0; font-size: 11pt">
                      ou parcelado em até
                      {{ value4.overDueInstallmentsNumber }}x
                    </p>
                  </div>
                </div>

                <div v-bind:class="largura < 500
                  ? 'col-5 text-right discount'
                  : 'col-4 text-center discount pl-0 pr-0'
                  " v-if="parseInt(value4.atSightPercentDiscount) > 0">
                  <p class="mb-0 mr-2" style="font-size: 8pt">
                    Desconto de até
                  </p>
                  <span class="discount-value" style="font-size: 13pt">
                    {{ value4.atSightPercentDiscount }}%
                    <!-- XX% -->
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="d-flex col-lg-12 col-12">
                  <p class="mb-1 mr-2" style="font-size: 10pt">
                    Valor original da dívida:
                  </p>
                  <h6 class="text-bold mb-0">
                    {{
                      formatFloatToReal(parseFloat(value4.originalValue, 10))
                    }}
                  </h6>
                </div>
                <div class="d-flex col-12 col-lg-12">
                  <p class="mb-1 mr-2" style="font-size: 10pt">
                    Vencimento original da dívida:
                  </p>
                  <h6>{{ formatData(value4.dueDate, "YYYY-MM-DD", "L") }}</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="d-flex float-right clearfix" style="cursor: pointer">
                    <a @click="toggleDropdownDetailsDebtsFianca(value4)" id="toggle-all-details"
                      class="subtt mb-0 text-body" v-if="value4.installments.length > 0"
                      style="text-decoration:underline;cursor:pointer;position:relative; font-size: 10pt;">
                      ver detalhes&nbsp;&nbsp;
                      <i v-if="value4 !== selectedCardFianca" class="fa fa-angle-down fa-lg"></i>

                      <i v-else class="fa fa-angle-up fa-lg"></i>
                    </a>
                  </div>
                </div>

                <div class="col-12 mt-2" v-if="value4 === selectedCardFianca">
                  <div class="clearfix mt-3"></div>
                  <hr class="mb-2" />
                  <p class="mt-3" style="font-weight: bold">Parcelas</p>
                  <div class="table-responsive">
                    <table class="table">
                      <thead v-if="value4.installments.length > 0">
                        <tr>
                          <th>Vencimento</th>
                          <th>Valor</th>
                          <th>Situação</th>
                        </tr>
                      </thead>
                      <thead v-if="value4.installments.length === 0">
                        <tr>
                          <th>Não há parcelas neste contrato.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(installment, index1) in value4.installments" :key="index1">
                          <td :class="index1 === value4.installments.length - 1 ? 'last-installment-cell' : ''">
                            {{
                              installment.dueDate
                                ? formatDateToDayMonthYear(installment.dueDate)
                                : "--"
                            }}
                          </td>
                          <td :style="index1 === value4.installments.length - 1
                            ? 'padding-bottom: 10px;'
                            : ''
                            ">
                            {{
                              formatFloatToReal(
                                parseFloat(installment.paymentValue, 10)
                              )
                            }}
                          </td>
                          <td :style="index1 === value4.installments.length - 1
                            ? 'padding-bottom: 10px;'
                            : ''
                            ">
                            {{ installment.status }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-bind:class="[
                largura < 500
                  ? 'row d-flex justify-content-center'
                  : 'row d-flex justify-content-center mt-2',
              ]">
                <div v-bind:class="[
                  largura < 500
                    ? 'text-center col-md-12 mt-4'
                    : 'text-center col-md-12 mt-3',
                ]">
                  <button class="btn btn-primary mr-2 mb-4 p-3" style="width: 100%; border-radius: 20px"
                    :disabled="user.DocNumber === '25993087803'"
                    @click="offersFianca('negociar', value4)">
                    NEGOCIAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!--row agreements-->
      <div v-bind:class="[largura < 500 ? '' : 'cards-container-desktop']" style="" v-show="agreements.length > 0">
        <div v-bind:class="[
          largura < 500
            ? 'd-flex p-2 mt-4'
            : 'agreements-header-desktop',
        ]" style="justify-content: space-between" v-if="!loading">
          <h5 class="text-bold mt-2">Meus acordos</h5>
          <a class="nav-link dropdown-toggle" href="#cardSection" id="userDropdown" role="button"
            @click="toggleDropdown" aria-haspopup="true" aria-expanded="dropdownOpen">
            <i v-if="!dropdownOpen" class="fa fa-angle-down fa-lg"></i>
            <i v-if="dropdownOpen" class="fa fa-angle-up fa-lg"></i>
          </a>
        </div>
        <div v-bind:class="[
          largura < 500
            ? ''
            : 'card-wrapper-desktop',
        ]" v-for="(value4, key4, index4) in agreements" :key="`${'d' + key4}-${index4}`"
          aria-labelledby="userDropdown">
          <div id="cardSection" v-bind:class="[largura < 500 ? 'card mb-4 m-2' : 'card']" v-show="dropdownOpen">
            <div class="card-header">
              <div v-bind:class="[largura < 500 ? '' : '']" style="">
                <div class="col-12 pl-0">
                  <!-- <h6 class="float-right rounded px-2 py-1 small bg-light">
                    Negociação realizada
                  </h6> -->
                  <h5 style="color: black" v-if="value4.credor !== 'CONSORCI'">
                    <!-- {{  value4.product.substring(0, 25) }} -->
                    {{
                      typeof value4.product !== "number"
                        ? value4.product.substring(0, 25)
                        : "Seguro Fiança - Essencial"
                    }}
                  </h5>
                  <h5 style="color: black" v-else>
                    {{ fromToConsorcioProduct[value4.product] }}
                  </h5>
                  <div class="col-12" v-if="value4.credor == 'CONSORCI'">
                    <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                      <p class="mb-1">Grupo:</p>
                      <h6 class="mb-0">{{ value4.group || value4.groupId || '-' }}</h6>
                    </div>
                    <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                      <p class="mb-1">Cota:</p>
                      <h6 class="mb-0">{{ value4.cota || '-' }}</h6>
                    </div>
                  </div>
                  <p style="font-size: 10pt" class="mb-0" v-if="typeof value4.product === 'number'">
                    <b style="color: black">Endereço da locação:</b>
                    {{ value4.address.street }}, {{ value4.address.number }} -
                    {{ value4.address.neighbourhood }}, <br />
                    {{ value4.address.cep }} {{ value4.address.city }} -
                    {{ value4.address.state }}
                  </p>
                  <p class="mb-0" v-if="typeof value4.product === 'number'">
                    <b style="color: black">Sinistro:</b> {{ value4.clientCode }}
                  </p>
                </div>
              </div>
            </div>
            <hr class="mr-2 ml-2" v-if="value4.credor !== 'CONSORCI'" />
            <div class="card-body" :style="largura < 500 ? 'margin-top: -15px;' : ''" v-if="value4.credor !== 'CONSORCI'">
              <div class="row">
                <div class="d-flex col-12 col-lg-12" style="justify-content: space-between">
                  <p class="mb-1">Nº do contrato:</p>
                  <h6 class="">{{ value4.contract }}</h6>
                </div>
                <div class="d-flex col-lg-12 col-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Valor negociado:</p>
                  <h6 class="">
                    R$
                    {{
                      parseFloat(value4.negociatedValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </h6>
                </div>
                <div class="d-flex col-lg-12 col-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Plano:</p>
                  <h6 class="" v-if="value4.installmentNumber <= 1">
                    À vista&nbsp;
                  </h6>
                  <h6 class="" v-if="value4.installmentNumber > 1">
                    {{ value4.installmentNumber }}x&nbsp;
                  </h6>
                </div>
              </div>
              <div class="row">
                <div class="d-flex col-lg-12 col-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Condições:</p>
                  <h6 class="text-body" v-if="value4.installmentNumber > 1" :style="caractersCount(value4) > 35
                    ? 'font-size: 10pt; margin-top: 3px;'
                    : ''
                    ">
                    Entrada R$
                    {{
                      parseFloat(value4.firstInstallmentValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                    + {{ value4.installmentNumber - 1 }}x de R$
                    {{
                      parseFloat(value4.installmentsValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </h6>

                  <h6 class="text-body" v-if="value4.installmentNumber <= 1">
                    {{ value4.installmentNumber }}x de R$
                    {{
                      parseFloat(value4.firstInstallmentValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </h6>
                </div>
              </div>
              <div class="row">
                <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Parcela(s) em aberto:</p>
                  <h6 class="">
                    {{ value4.overdueInstallments }}/{{
                      value4.installmentNumber
                    }}
                  </h6>
                </div>
                <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Vencimento:</p>
                  <h6>{{ formatData(value4.dueDate, "YYYY-MM-DD", "L") }}</h6>
                </div>
              </div>
              <div class="row mt-3">
                <div class="text-center col-md-12">
                  <button class="btn mb-2 btn-primary p-3" style="width: 100%; border-radius: 20px"
                    @click="verBoletosSemDebts(value4)">
                    VER ACORDO
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body pt-0" :style="largura < 500 ? 'margin-top: -15px;' : ''" v-if="value4.credor == 'CONSORCI'">
              <!-- <hr /> -->
              <!-- <div class="row">
                <div class="d-flex col-12 col-lg-12" style="justify-content: space-between">
                  <p class="mb-1">Despesas:</p>
                  <h6 class="">R$ {{ parseFloat(parseFloat(value4.negociatedValue) - parseFloat(value4.paymentValue)).toLocaleString("pt-BR", {
                        currency: "BRL",
                        minimumFractionDigits: 2,
                      }) }}</h6>
                </div>
                <div class="d-flex col-lg-12 col-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Vencimento:</p>
                  <h6 class="">
                    R$
                    {{
                      parseFloat(value4.negociatedValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </h6>
                </div>
                
              </div> -->
              <hr class="mt-0" />
              <!-- <div class="row">
                <div class="d-flex col-lg-12 col-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Parcela:</p>
                  <h6 class="" v-if="value4.installmentNumber <= 1">
                    À vista&nbsp;
                  </h6>
                  <h6 class="" v-if="value4.installmentNumber > 1">
                    {{ value4.installmentNumber }}x&nbsp;
                  </h6>
                </div>
                <div class="d-flex col-lg-12 col-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Valor:</p>
                  <h6 class="text-body" v-if="value4.installmentNumber > 1" :style="caractersCount(value4) > 35
                    ? 'font-size: 10pt; margin-top: 3px;'
                    : ''
                    ">
                    Entrada R$
                    {{
                      parseFloat(value4.firstInstallmentValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                    + {{ value4.installmentNumber - 1 }}x de R$
                    {{
                      parseFloat(value4.installmentsValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </h6>

                  <h6 class="text-body" v-if="value4.installmentNumber <= 1">
                    {{ value4.installmentNumber }}x de R$
                    {{
                      parseFloat(value4.firstInstallmentValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}
                  </h6>
                </div>
                
              </div> -->
              <!-- <hr /> -->
              <div class="row">
                <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Parcela(s) em aberto:</p>
                  <h6 class="">
                    {{ value4.overdueInstallments }}/{{
                      value4.installmentNumber
                    }}
                  </h6>
                </div>
                <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Valor do acordo:</p>
                  <h6>R$ {{
                      parseFloat(value4.negociatedValue).toLocaleString(
                        "pt-BR",
                        {
                          currency: "BRL",
                          minimumFractionDigits: 2,
                        }
                      )
                    }}</h6>
                </div>
                <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Vencimento do acordo:</p>
                  <h6>{{ formatData(value4.dueDate, "YYYY-MM-DD", "L") }}</h6>
                </div>
                <div class="d-flex col-12 col-lg-12 py-0" style="justify-content: space-between">
                  <p class="mb-1">Forma de pagamento:</p>
                  <h6>Boleto</h6>
                </div>
              </div>
              <!-- <hr /> -->
              <div class="row mt-3">
                <div class="text-center col-md-12">
                  <button class="btn mb-2 btn-primary p-3" style="width: 100%; border-radius: 20px"
                    @click="verBoletosSemDebts(value4)">
                    GERAR BOLETO
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="loading">
      <ProgressLoading v-bind:loading="loading" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
  formatStringToLowerCase,
  formatFloatToReal,
  formatDateToDayMonthYear,
} from "@/utils/helpers";
import { shouldRedirectToWhatsApp } from "@/utils/consorcioNegotiationRules";
import { markPortoViewedOffersLog, persistSelectedCredor, shouldLogViewedOffersOnDashboardNegotiate } from "@/utils/portoAccessLog";
import { mapState } from "vuex";
import ProgressLoading from "../../modules/auth/components/ProgressLoading.vue";
import HomeOptions from "./components/HeaderMenu.vue";
import { initializeGlobals } from "@/global";
import { EventBus } from "@/utils/EventBus";

export default {
  name: "Dashboard",
  components: {
    ProgressLoading,
    HomeOptions,
  },
  data() {
    return {
      showDebtsSum: true,
      debts: [],
      debtsContencioso: [],
      debtsCdc: [],
      debtsFianca: [],
      debtsConsorcio: [],
      agreements: [],
      showNoContractsOrAgreements: false,
      largura: null,
      selectAll: false,
      checkedParcels: [],
      loading: false,
      sumTotalInstallmentsCdc: null,
      totalInstallmentsCdcWithFees: null,
      errorMessage: {},
      pageLocation: null,
      userDataStorage: {},
      url: null,
      protocol: null,
      path: null,
      host: null,
      userAdm: {},
      ipUser: null,
      dropdownOpen: false,
      thereIsDebts: false,
      credorType: {
        debtsContencioso: [4, 9, 33],
        debtsCdc: [5],
        debts: [2, 7],
        debtsFianca: [74604, 74600],
        debtsConsorcio: ['CONSORCI']
      },
      fromToConsorcioProduct: {
        'IMV': 'CONSORCIO - IMÓVEIS',
        'AUT': 'CONSORCIO - AUTOMÓVEIS'
      },
      fromToConsorcioType: {
        'nao contemplado': 'Ativa (não contemplado)',
        'contemplado sem bem': 'Ativa (contemplado sem bem)',
        'contemplado com bem': 'Ativa (contemplado com bem)'
      },
      dropDownDetailsdebtsFianca: false,
      selectedCardFianca: null,
      selectedCardsConsorcio: [],
    };
  },
  mounted() {
    this.$emit("updatePageView", this.pageLocation);
    localStorage.removeItem("authUser");
    // Escuta evento para refresh dos debts mantendo chat aberto
    EventBus.$on("refresh-debts-keep-chat-open", this.loadDebts);
  },
  beforeDestroy() {
    // Remove listener do evento
    EventBus.$off("refresh-debts-keep-chat-open", this.loadDebts);
  },
  async created() {
    this.updateCustomData();
    this.ipUser = localStorage.getItem("ipUser");
    localStorage.setItem("currentPageName", "dashboard");
    this.userDataStorage = JSON.parse(localStorage.getItem("userData"));
    this.userAdm = JSON.parse(localStorage.getItem("userAdm"));

    this.url = window.location.href;
    this.buildAndSetUserData(
      this.userDataStorage.cpfCnpj,
      this.userDataStorage.id,
      this.url,
      "Dashboard"
    );

    this.protocol = window.location.protocol;
    this.host = window.location.host;
    this.path = window.location.pathname;
    this.pageLocation = this.protocol + "//" + this.host + this.path;

    this.largura = window.screen.width;

    // Carrega debts inicialmente
    await this.loadDebts();
  },

  methods: {
    formatValue,
    formatData,
    formatDocument,
    formatStringToLowerCase,
    formatFloatToReal,
    formatDateToDayMonthYear,

    async loadDebts() {
      this.loading = true;
      // Credor 2 e 7: sempre mostrar passos do Avatar e IA (dívidas amigáveis ou acordo fechado)
      const isCredorAmigavel = (credor) => Number(credor) === 2 || Number(credor) === 7;

      // Limpa arrays antes de recarregar
      this.debts = [];
      this.debtsContencioso = [];
      this.debtsCdc = [];
      this.debtsFianca = [];
      this.debtsConsorcio = [];
      this.agreements = [];
      this.thereIsDebts = false;
      this.showNoContractsOrAgreements = false;

      try {
        const tag = localStorage.getItem("tag");
        const contracts = await this.ActionGetDebtsPortoSeguro({
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          tag: tag,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        if (contracts.debts?.length > 0) {
          localStorage.setItem(
            "credor",
            JSON.stringify(contracts.debts[0].credor)
          );
        }

        if (contracts.agreements?.length > 0) {
          localStorage.setItem(
            "credor",
            JSON.stringify(contracts.agreements[0].credor)
          );
        }

        if (contracts.debts?.length) {
          contracts.debts.map((item) => {
            item.selected = false;
            item.parcelsIsFromCurrentContract = false;
          });

          this.checkContractRules(contracts);

          contracts.debts?.forEach((contract) => {
            const credor = Number(contract.credor);
            if (this.credorType.debtsContencioso.includes(credor)) {
              this.debtsContencioso.push(contract);
            } else if (this.credorType.debtsCdc.includes(credor)) {
              this.debtsCdc.push(contract);
            } else if (this.credorType.debts.includes(credor)) {
              this.debts.push(contract);
            } else if (this.credorType.debtsFianca.includes(credor)) {
              this.debtsFianca.push(contract);
            } else if (this.credorType.debtsConsorcio.includes(contract.credor)) {
              this.debtsConsorcio.push(contract);
            }
          });

          this.thereIsDebts = true;
        }

        if (contracts.agreements?.length > 0) {
          this.checkContractRules(contracts);
          this.agreements =
            contracts.agreements.length > 0 ? contracts.agreements : [];
          this.toggleDropdown();
        } else if (!contracts.debts?.length && !contracts.agreements?.length) {
          this.showNoContractsOrAgreements = true;
          this.errorMessage = contracts;
        }

        this.pageLocation = window.location.href;
      } catch {
        this.loading = false;
        this.showNoContractsOrAgreements = true;
      } finally {
        this.loading = false;
        // Emite evento para avisar que as dívidas terminaram de carregar
        const hasAmigavelDebts = this.debts && this.debts.length > 0;
        const hasAmigavelAgreements = this.agreements && this.agreements.length > 0 &&
          this.agreements.some((agreement) => isCredorAmigavel(agreement.credor));
        const shouldShowAI = hasAmigavelDebts || hasAmigavelAgreements;
        EventBus.$emit("debts-loaded", { hasAmigavelDebts: shouldShowAI });
      }
    },

    // Verifica se uma parcela é de diferença (installmentNumber = 0 e C_PCTIPD = 2)
    isDiffInstallment(inst) {
      const installmentNumber = parseInt(inst.installmentNumber || 0);
      const c_pctipd = String(inst.C_PCTIPD || inst.c_pctipd || "");
      return installmentNumber === 0 && c_pctipd === "2";
    },

    // Verifica se uma parcela é de custas (situation = cost ou C_PCTIPD = 3)
    isCostInstallment(inst) {
      const situation = (inst.situation || "").toLowerCase();
      const c_pctipd = String(inst.C_PCTIPD || inst.c_pctipd || "");
      return situation === "cost" || c_pctipd === "3";
    },

    getInstallmentsConsorcioRange(installments = []) {
      if (!installments?.length) {
        return 'Parcelas: Nenhuma parcela encontrada.';
      }

      // Separa parcelas normais, de diferença e de custas
      const normalInstallments = installments.filter(
        inst => !this.isDiffInstallment(inst) && !this.isCostInstallment(inst)
      );
      const diffInstallments = installments.filter(inst => this.isDiffInstallment(inst));
      const costInstallments = installments.filter(inst => this.isCostInstallment(inst));

      let result = [];

      // Adiciona informação de diferença de parcela primeiro (se houver)
      if (diffInstallments.length > 0) {
        result.push('Diferença de parcela anterior');
      }

      // Adiciona informação de custas (se houver)
      if (costInstallments.length > 0) {
        result.push('Custas');
      }

      // Monta "Parcela: X" ou "Parcela(s): X a Y"
      if (normalInstallments.length > 0) {
        const sorted = [...normalInstallments].sort((a, b) => parseInt(a.installmentNumber) - parseInt(b.installmentNumber));
        const first = sorted[0].installmentNumber;
        const last = sorted[sorted.length - 1].installmentNumber;
        if (normalInstallments.length === 1) {
          result.push(`Parcela: ${first}`);
        } else {
          result.push(`Parcela(s): ${first} a ${last}`);
        }
      }

      return result.join('\n');
    },

    checkContractRules(contracts) {
      contracts.debts?.map((contract) => {
        if (contract.pstPaymentValue <= 0 || contract.pstOriginalValue <= 0)
          this.showDebtsSum = false;
      });
    },

    persistCredorFromDashboard(offerInfo) {
      if (offerInfo && offerInfo.credor != null) {
        persistSelectedCredor(offerInfo.credor);
      }
    },

    async markViewedOffersForCredor(offerInfo) {
      this.persistCredorFromDashboard(offerInfo);
      if (!shouldLogViewedOffersOnDashboardNegotiate(offerInfo && offerInfo.credor)) {
        return;
      }
      await markPortoViewedOffersLog({
        offerInfo,
        userAdm: this.userAdm,
        ipUser: this.ipUser,
        debtorUser: this.user,
        contacts: this.contacts,
      });
    },

    async offersFaturaPropostas(offerInfo) {
      // this.eventClickToParcelarOuEmitirFaturaGTM(
      //   "parcelar-fatura",
      //   offerInfo
      // );
      await this.markViewedOffersForCredor(offerInfo);
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/propostas",
        "propostas"
      );
      this.updateCustomData();
      this.$router.push({
        name: "propostas",
        params: { offerInfo },
      });
    },

    async offersFaturaContencioso(event, offerInfo) {
      this.eventClickNegociarOuDescontosDisponiveisGTM(
        event,
        offerInfo.product
      );
      await this.markViewedOffersForCredor(offerInfo);
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/propostasContencioso",
        "propostasContencioso"
      );
      this.updateCustomData();
      this.$router.push({
        name: "propostasContencioso",
        params: { offerInfo },
      });
    },

    async offersConsorcio(offerInfo) {
      console.log("offerInfo: " + JSON.stringify(offerInfo));
      this.eventClickNegociarOuDescontosDisponiveisGTM(
        'negociar',
        offerInfo.product
      );
      await this.markViewedOffersForCredor(offerInfo);
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/propostasConsorcio",
        "propostasConsorcio"
      );
      const debtsConsorcio = this.debtsConsorcio.filter(debt => debt.contract === offerInfo.contract);
      this.updateCustomData();
      this.$router.push({
        name: "propostasConsorcio",
        params: {
          debtsConsorcio,
          offerInfo: offerInfo,
          sumTotalInstallmentsConsorcio: this.sumTotalInstallmentsConsorcio
        },
      });
    },

    async offersCdc(agreementInfo) {
      console.log("agreementInfo: " + JSON.stringify(agreementInfo));


      this.eventClickNegociarOuDescontosDisponiveisGTM(
        "negociar",
        agreementInfo.product
      );

      await this.markViewedOffersForCredor(agreementInfo);

      // Filtrar apenas o contrato específico que está sendo negociado
      const filteredDebtsCdc = this.debtsCdc.filter(debt => debt.contract === agreementInfo.contract);

      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/propostasCdc",
        "propostasCdc"
      );
      this.updateCustomData();
      this.$router.push({
        name: "propostasCdc",
        params: {
          debtsCdc: filteredDebtsCdc,
          agreements: this.agreements,
          agreementInfo: agreementInfo,
          sumTotalInstallmentsCdc: this.sumTotalInstallmentsCdc,
          // totalInstallmentsCdcWithFees: this.totalInstallmentsCdcWithFees,
        },
      });
    },

    async offersFianca(event, offerInfo) {
      this.eventClickNegociarOuDescontosDisponiveisGTM(
        event,
        offerInfo.product
      );
      await this.markViewedOffersForCredor(offerInfo);
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/propostasFianca",
        "propostasFianca"
      );
      this.updateCustomData();
      this.$router.push({
        name: "propostasFianca",
        params: { offerInfo },
      });
    },

    ...mapActions("meusContratos", ["ActionGetDebtsPortoSeguro"]),

    async verBoletos(value) {
      this.loading = true;
      this.eventClickToParcelarOuEmitirFaturaGTM("emitir-fatura", value);
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/meus-boletos",
        "meus-boletos"
      );
      this.updateCustomData();
      this.$router.push({
        name: "meusBoletos",
        params: {
          agreementInfo: value,
          fromEmitirFatura: true,
        },
      });
    },

    async verBoletosSemDebts(value) {
      this.loading = true;
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/meus-boletos",
        "meus-boletos"
      );
      this.updateCustomData();
      this.$router.push({
        name: "meusBoletos",
        params: { agreementInfo: value, fromAgreements: true },
      });
    },

    eventClickToParcelarOuEmitirFaturaGTM(action, item) {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = `click:button:${action}`;

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: formatStringToLowerCase(item.product),
      };

      window.dataLayer.push({ ...eventData });
    },

    buildAndSetUserData(doc, id, pageLocation, pageName) {
      // const pageName = this.$options.name;
      const userData = {
        cpfCnpj: doc, // Substitua pelo CPF/CNPJ real
        id: id, // Substitua pelo ID real
        page_location: pageLocation,
        pageName: pageName,
      };
      localStorage.setItem("userData", JSON.stringify(userData));
    },

    eventClickNegociarOuDescontosDisponiveisGTM(option, product) {
      var nameProductFormated = product;
      if (
        typeof product === "string" &&
        product.trim() !== "" &&
        isNaN(product)
      ) {
        nameProductFormated = null;
        formatStringToLowerCase(product);
      }
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = `click:button:${option}`;

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: nameProductFormated,
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    updateCustomData() {
      const globals = initializeGlobals();
      window.customData = globals.customData;
    },

    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    toggleDropdownDetailsDebtsFianca(card) {
      if (this.selectedCardFianca === card) {
        this.selectedCardFianca = null;
      } else {
        this.selectedCardFianca = card;
      }
    },

    getCardConsorcioKey(card) {
      // Gera uma chave única para cada card baseada em contract, group e cota
      return `${card.contract || ''}_${card.group || ''}_${card.cota || ''}`;
    },

    isCardConsorcioExpanded(card) {
      const key = this.getCardConsorcioKey(card);
      return this.selectedCardsConsorcio.includes(key);
    },

    toggleDropdownDetailsDebtsConsorcio(card) {
      const key = this.getCardConsorcioKey(card);
      const index = this.selectedCardsConsorcio.indexOf(key);
      if (index > -1) {
        this.selectedCardsConsorcio.splice(index, 1);
      } else {
        this.selectedCardsConsorcio.push(key);
      }
    },

    thereIsAgreementCdcClosed(contractNumber) {
      var result =
        this.agreements.filter(function (val) {
          return val.contract === contractNumber;
        }).length > 0;

      return result;
    },

    /**
     * Verifica se o contrato de consórcio deve redirecionar ao WhatsApp
     * Condições:
     * 1. allowNegotiation === false (nova regra da API)
     * 2. CONTEMPLADO COM BEM com mais de 30 dias de atraso (regra existente)
     */
    shouldRedirectConsorcioToWhatsApp(contract) {
      if (!contract) return false;
      
      // Verifica se allowNegotiation é false (nova regra da API)
      // Quando a API retorna allowNegotiation: false, devemos desabilitar o botão NEGOCIAR
      // e direcionar o cliente para o WhatsApp
      if (contract.allowNegotiation === false) {
        console.log("[Dashboard] allowNegotiation is false for contract:", contract.contract || contract.group);
        return true;
      }
      
      // Regra existente: CONTEMPLADO COM BEM com mais de 30 dias
      const result = shouldRedirectToWhatsApp(contract);
      return result.shouldRedirect;
    },

    caractersCount(value) {
      return `Entrada R$
                    ${parseFloat(value.firstInstallmentValue).toLocaleString(
        "pt-BR",
        {
          currency: "BRL",
          minimumFractionDigits: 2,
        }
      )}
                    + ${value.installmentNumber - 1}x de R$
                    ${parseFloat(value.installmentsValue).toLocaleString(
        "pt-BR",
        {
          currency: "BRL",
          minimumFractionDigits: 2,
        }
      )}`.length;
    },
  },

  computed: {
    ...mapState("auth", ["user", "contacts"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>
<style>
#userDropdown::after {
  display: none !important;
  /* Isso vai remover a seta */
}

html {
  scroll-behavior: smooth;
}

.table {
  font-size: 10px;
  margin: 0px;
  padding-left: 0;
  padding-top: 8px;
  padding-right: 2px;
  text-align: center;
  background-color: #eff0f2;
}

td {
  padding-top: 5px !important;
  padding-bottom: 0px !important;
}

.last-installment-cell {
  padding-bottom: 10px !important;
}
</style>
